import {TicketMyResultVo} from '../../common/shared/api/nicolas/vo/TicketMyResultVo.interface';
import {ContentMyTicket} from '../generated/types';
import {createContentWaitfreeInfo} from './ContentWaitfreeInfo';

export function createContentMyTicket({
  my,
  library,
  waitfree,
}: TicketMyResultVo): ContentMyTicket {
  return {
    ticketOwnCount: my.ticket_own_count,
    ticketRentalCount: my.ticket_rental_count,
    notOwnCount: library?.not_own_count,
    notReadCount: library?.not_read_count,
    waitfree: waitfree && createContentWaitfreeInfo(waitfree),
  };
}
